import React, {memo} from 'react';
import Styles from "./ErrorImage.module.css"
import ErrorInfoIcon from "../../assets/Alert-Info_red.svg";
import {useTranslation} from "react-i18next";
// import _ from 'lodash'

type StyleType = 'warning' | 'error';
interface Props {
    title:string,
    hideIcon?:boolean,
    style?:any,
    icon?:string
    type?: StyleType
}

const ErrorImage = (props:Props) => {
    const { t } = useTranslation();
    let defaultStyle = [Styles.titleWarningText];
    if(props.type === "warning") defaultStyle.push(Styles.titleHelpText);
    else defaultStyle.push(Styles.titleErrorText)
    // let componentStyle = _.isEmpty(props.style) ? defaultStyle.join(" ") : {...(props.style||{})};
    return (
        <span className={defaultStyle.join(" ")} >
            { !props.hideIcon ? <img
                style={{ marginRight: '0.5rem' }}
                src={props.icon || ErrorInfoIcon}
                className={Styles.errorIcon}
                alt=""
            /> : ""}
            {t(props.title)}
        </span>
    );

};

export default memo(ErrorImage);
